export const card =[
    {
        id:0,
        title:"Web Development",
        desc:"build your web",
        img:"https://c0.wallpaperflare.com/preview/729/37/117/advanced-ai-anatomy-artificial.jpg"
    },
    {
        id:1,
        title:"Web Development",
        desc:"build your web",
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg"
    },
    {
        id:2,
        title:"Web Development",
        desc:"build your web",
        img:"https://c1.wallpaperflare.com/preview/479/432/938/wordpress-hand-logo-background-image.jpg"
    },
    {
        id:3,
        title:"Web Development",
        desc:"build your web",
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg"
    },
    {
        id:4,
        title:"Web Development",
        desc:"build your web",
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg"
    },
    {
        id:5,
        title:"Web Development",
        desc:"build your web",
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg"
    }
]

export const Projects =[
    {
        id:0,
        title:"Gig",
        name:"John Doe",
        img:"https://c0.wallpaperflare.com/preview/729/37/117/advanced-ai-anatomy-artificial.jpg"
    },
    {
        id:1,
        title:"Gig",
        name:"John Doe",
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg"
    },
    {
        id:2,
        title:"Gig",
        name:"John Doe",
        img:"https://c1.wallpaperflare.com/preview/479/432/938/wordpress-hand-logo-background-image.jpg"
    },
    {
        id:3,
        title:"Gig",
        name:"John Doe",
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg"
    },
    {
        id:4,
        title:"Gig",
        name:"John Doe",
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg"
    },
    {
        id:5,
        title:"Gig",
        name:"John Doe",
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg"
    }
]


export const gigs = [
    {
        id:0,
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg",
        username:"John Doe",
        desc:"Gig desc",
        price:100,
        star:3
    },
    {
        id:1,
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg",
        username:"John Doe",
        desc:"Gig desc",
        price:100,
        star:3
    },
    {
        id:2,
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg",
        username:"John Doe",
        desc:"Gig desc",
        price:100,
        star:3
    },
    {
        id:3,
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg",
        username:"John Doe",
        desc:"Gig desc",
        price:100,
        star:3
    },
    {
        id:4,
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg",
        username:"John Doe",
        desc:"Gig desc",
        price:100,
        star:3
    },
    {
        id:5,
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg",
        username:"John Doe",
        desc:"Gig desc",
        price:100,
        star:3
    },
    {
        id:6,
        img:"https://c4.wallpaperflare.com/wallpaper/964/55/598/digital-digital-art-artwork-illustration-simple-hd-wallpaper-preview.jpg",
        username:"John Doe",
        desc:"Gig desc",
        price:100,
        star:3
    }
]


export const cats = [
    {
        id:0,
        title:"AI Artists",
        desc:"Add talent to ai",
        img:"https://cdn.pixabay.com/photo/2023/04/18/15/19/ai-generated-7935369_1280.jpg"
    },
    {
        id:1,
        title:"logo design",
        desc:"buid your brand",
        img:"https://cdn.pixabay.com/photo/2017/11/16/09/13/monogram-2953821_1280.png"
    },
    {
        id:2,
        title:"Wordpress",
        desc:"customize your website",
        img:"https://c1.wallpaperflare.com/preview/479/432/938/wordpress-hand-logo-background-image.jpg"
    },
    {
        id:3,
        title:"video and animation",
        desc:"Engaging and Memorable",
        img:"https://c4.wallpaperflare.com/wallpaper/937/974/490/one-piece-zoro-1280x1806-anime-one-piece-hd-art-wallpaper-preview.jpg"
    },
    {
        id:4,
        title:"graphic design",
        desc:"style ur work",
        img:"https://c4.wallpaperflare.com/wallpaper/523/474/380/mask-demon-samurai-chun-lo-wallpaper-preview.jpg"
    },
    {
        id:5,
        title:"illustration",
        desc:"draw your imagination",
        img:"https://cdn.pixabay.com/photo/2022/03/31/14/53/camp-7103189_1280.png"
    },
    {
        id:6,
        title:"seo",
        desc:"unlock growth online",
        img:"https://cdn.pixabay.com/photo/2020/04/04/03/42/market-5000694_1280.png"
    },
    {
        id:7,
        title:"Music and audio",
        desc:"share your voice",
        img:"https://cdn.pixabay.com/photo/2013/07/12/18/17/equalizer-153212_1280.png"
    },
    {
        id:8,
        title:"social media",
        desc:"reach more customers",
        img:"https://c0.wallpaperflare.com/preview/278/663/591/posting-post-computer-icon.jpg"
    }

]




export const courses = [
    { value: 'bca', label: 'BCA' },
    { value: 'bscsit', label: 'BScIT' },
    { value: 'btech', label: 'BTech' },
    { value: 'ba', label: 'BA' },
    { value: 'bcom', label: 'BCom' },
    { value: 'bba', label: 'BBA' },
    { value: 'mba', label: 'MBA' },
    { value: 'mca', label: 'MCA' },
    { value: 'msc', label: 'MSc' },
    { value: 'phd', label: 'PhD' },
    { value: 'diploma', label: 'Diploma' },
    // Add more course options as needed
  ];

  export const skills = [
    { value: 'web-development', label: 'Web Development' },
    { value: 'seo', label: 'SEO' },
    { value: 'logo-design', label: 'Logo Design' },
    { value: 'graphic-design', label: 'Graphic Design' },
    { value: 'content-writing', label: 'Content Writing' },
    { value: 'social-media-marketing', label: 'Social Media Marketing' },
    { value: 'video-editing', label: 'Video Editing' },
    { value: 'wordpress-development', label: 'WordPress Development' },
    { value: 'mobile-app-development', label: 'Mobile App Development' },
    { value: 'data-entry', label: 'Data Entry' }
  ];  


  export const languageOptions = [
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Spanish' },
    { value: 'fr', label: 'French' },
    { value: 'de', label: 'German' },
    { value: 'it', label: 'Italian' },
    { value: 'pt', label: 'Portuguese' },
    { value: 'ru', label: 'Russian' },
    { value: 'ja', label: 'Japanese' },
    { value: 'ko', label: 'Korean' },
    { value: 'zh', label: 'Chinese' },
    { value: 'ar', label: 'Arabic' },
    { value: 'hi', label: 'Hindi' },
    { value: 'id', label: 'Indonesian' },
    { value: 'nl', label: 'Dutch' },
    { value: 'sv', label: 'Swedish' },
    { value: 'fi', label: 'Finnish' },
    { value: 'da', label: 'Danish' },
    { value: 'no', label: 'Norwegian' },
    { value: 'tr', label: 'Turkish' },
    { value: 'pl', label: 'Polish' },
    { value: 'cs', label: 'Czech' },
    { value: 'hu', label: 'Hungarian' },
    { value: 'ro', label: 'Romanian' },
    { value: 'sk', label: 'Slovak' },
    { value: 'sl', label: 'Slovenian' },
    { value: 'uk', label: 'Ukrainian' },
    { value: 'he', label: 'Hebrew' },
    { value: 'el', label: 'Greek' },
    { value: 'th', label: 'Thai' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'bg', label: 'Bulgarian' },
    { value: 'ne', label: 'Nepali' },
  ]; 



  export const userRows = [
    {
      id: 1,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jon@gmail.com",
      status: "active",
    },
    {
      id: 2,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jon@gmail.com",
      status: "active",
    },
    {
      id: 3,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jon@gmail.com",
      status: "active",
    },
    {
      id: 4,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jon@gmail.com",
      status: "active",
    },
    {
      id: 5,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jon@gmail.com",
      status: "active",
    },
    {
      id: 6,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jon@gmail.com",
      status: "active",
    },
    {
      id: 7,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jon@gmail.com",
      status: "active",
    },
    {
      id: 8,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jon@gmail.com",
      status: "active",
    },
    {
      id: 9,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jon@gmail.com",
      status: "active",
    },
    {
      id: 10,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jon@gmail.com",
      status: "active",
    },
  ];



  export const gigRows = [
    {
      id: 1,
      title: "Jon Snow",
      cover:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      price: 100,
      desc: "active",
    },
    {
      id: 2,
      title: "Jon Snow",
      cover:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      price: 100,
      desc: "active",
    },
    {
      id: 3,
      title: "Jon Snow",
      cover:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      price: 100,
      desc: "active",
    },
    {
      id: 4,
      title: "Jon Snow",
      cover:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      price: 100,
      desc: "active",
    },
    {
      id: 5,
      title: "Jon Snow",
      cover:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      price: 100,
      desc: "active",
    },
    {
      id: 6,
      title: "Jon Snow",
      cover:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      price: 100,
      desc: "active",
    },
    {
      id: 7,
      title: "Jon Snow",
      cover:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      price: 100,
      desc: "active",
    },
    {
      id: 8,
      title: "Jon Snow",
      cover:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      price: 100,
      desc: "active",
    },
    {
      id: 9,
      title: "Jon Snow",
      cover:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      price: 100,
      desc: "active",
    },
    {
      id: 10,
      title: "Jon Snow",
      cover:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      price: 100,
      desc: "active",
    },
  ];




 export const plans = [
    {
      name: "Non Original Content",
    },
    {
      name: "Inappropriate Gig",
    },
    {
      name: "Trademark Violations",
    },
    {
      name: "Copyright Violations",
    },
  ];
  